export interface InstallCheckResult {
  ok: boolean;
  issues: string[];
  warnings: string[];
}

export function checkInstall(): InstallCheckResult {
  const issues: string[] = [];
  const warnings: string[] = [];

  if (typeof window === "undefined") {
    issues.push("'window' não está disponível — a lib só funciona em browsers.");
  }
  if (typeof document === "undefined") {
    issues.push("'document' não está disponível — a lib só funciona em browsers.");
  }
  if (typeof fetch !== "function") {
    issues.push("'fetch' não está disponível — a lib requer browsers modernos (ES2020+).");
  }

  if (typeof window !== "undefined" && typeof window.SDKPrivacy !== "function") {
    issues.push(
      "'window.SDKPrivacy' não está carregada. Adicione <script src=\"https://www.gazetadopovo.com.br/sdk-privacy/SDKPrivacy.js\"></script> antes da GZIntegracoes.",
    );
  }

  if (typeof window !== "undefined" && window.GazetaDoPovo === undefined) {
    warnings.push(
      "'window.GazetaDoPovo' não está carregada. Necessária apenas para getGZSession — adicione <script src=\"https://www.gazetadopovo.com.br/assets/legacy/GazetaDoPovoSDK.js\"></script> se for usar a sessão do usuário.",
    );
  }

  return { ok: issues.length === 0, issues, warnings };
}
